import React, { useEffect, useRef } from 'react';

interface InstagramEmbedProps {
  videoId: string;
}

declare global {
  interface Window {
    instgrm?: {
      Embeds: {
        process: () => void;
      };
    };
  }
}

const InstagramEmbed: React.FC<InstagramEmbedProps> = ({ videoId }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const existingScript = document.querySelector('script[src*="instagram.com/embed.js"]');

    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://www.instagram.com/embed.js';
      script.async = true;

      script.onload = () => {
        if (window.instgrm?.Embeds) {
          window.instgrm.Embeds.process();
        }
      };

      document.body.appendChild(script);
    } else if (window.instgrm?.Embeds) {
      window.instgrm.Embeds.process();
    }
  }, [videoId]);

  if (!videoId) return null;

  const embedUrl = `https://www.instagram.com/reel/${videoId}/embed`;

  return (
    <div
      ref={containerRef}
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#000',
        overflow: 'hidden',
      }}
    >
      <iframe
        src={embedUrl}
        title="Instagram Video"
        style={{
          width: 'auto',
          height: '100%',
          minWidth: '325px',
          maxWidth: '540px',
          aspectRatio: '9 / 16',
          border: 'none',
        }}
        allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
        allowFullScreen
        scrolling="no"
      />
    </div>
  );
};

export default InstagramEmbed;
